import { Component, Input, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-title',
  template: `
    <div id="title" class="app-account-primary">
      <div class="mat-title">
        <a *ngIf="showBackArrow" mat-icon-button color="accent" (click)="goBack()">
          <mat-icon aria-label="Edit">arrow_back_ios</mat-icon>
        </a>
        <ng-content></ng-content>
      </div>
    </div>
    `,
  styles: [`
    #title {
      width: 100%;
      height: 56px;
      display: flex;
      align-items: center;
    }

    div.mat-title {
        margin: 0 10px;
    }
    `]
})
export class TitleComponent implements OnInit {

  @Input() back = undefined;
  showBackArrow = true;

  constructor(
    private _location: Location
  ) { }

  ngOnInit() {
    this.showBackArrow = this.back || this.back === undefined;
  }

  goBack(): void {
    this._location.back();
  }
}
